module.exports = __webpack_public_path__ + "img/schedule.f004eea5.svg";